module.exports = __webpack_public_path__ + "img/2 (5).41cc3e00.jpg";